import { render, staticRenderFns } from "./CorporaPage.vue?vue&type=template&id=6d33c313&scoped=true"
import script from "./CorporaPage.vue?vue&type=script&lang=ts"
export * from "./CorporaPage.vue?vue&type=script&lang=ts"
import style0 from "./CorporaPage.vue?vue&type=style&index=0&id=6d33c313&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d33c313",
  null
  
)

export default component.exports